var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_345_1846)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 5,
    fill: "#008945"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.7071,
    y1: 13.2929,
    x2: 31.3848,
    y2: 30.9706,
    stroke: "#F9F0ED",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 22,
    x2: 66,
    y2: 22,
    stroke: "#F9F0ED",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.2929,
    y1: 30.9706,
    x2: 30.9706,
    y2: 13.2929,
    stroke: "#F9F0ED",
    strokeWidth: 2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 42,
    height: 42,
    rx: 4,
    stroke: "#F9F0ED",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_345_1846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 5,
    fill: "white"
  })))));
};
export default SvgCross;